import { CountryCode, getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js';

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

export interface PhoneCountry {
  name: string;
  iso: CountryCode;
  dial: string;
}

export const PHONE_COUNTRIES: PhoneCountry[] = getCountries()
  .map((iso) => ({
    iso,
    name: regionNames.of(iso) ?? iso,
    dial: getCountryCallingCode(iso),
  }))
  .sort((a, b) => a.name.localeCompare(b.name, 'en'));

export function flag(iso: string): string {
  return [...iso.toUpperCase()].map((char) => String.fromCodePoint(127397 + char.charCodeAt(0))).join('');
}

export function toE164(raw: string, country: PhoneCountry): string | null {
  const parsed = parsePhoneNumberFromString(raw, country.iso);
  if (!parsed?.isValid() || parsed.country !== country.iso) {
    return null;
  }
  if (fakeNumber(parsed.nationalNumber)) {
    return null;
  }
  return parsed.number;
}

function fakeNumber(digits: string): boolean {
  if (/^(\d)\1+$/.test(digits)) {
    return true;
  }
  const rising = '01234567890123456789';
  const falling = '98765432109876543210';
  return rising.includes(digits) || falling.includes(digits);
}
